<template>
  <div class="box">
    <div id="app-home">
      <div class="container">
        <div class="goback">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="content">
          <div class="top">
            <img
              v-if="!info.fileId"
              class="img1"
              src="@/assets/newMedal/history/1.png"
              alt=""
            />
            <!-- <img
              v-if="!info.fileId && info.medalName?.includes('星光')"
              class="img1"
              src="@/assets/newMedal/history/xing.svg"
              alt=""
            />
            <img
              v-if="!info.fileId && info.medalName?.includes('荣光')"
              class="img1"
              src="@/assets/newMedal/history/rong.svg"
              alt=""
            />
            <img
              v-if="!info.fileId && info.medalName?.includes('雷士')"
              class="img1"
              src="@/assets/newMedal/history/lei.svg"
              alt=""
            />

            <img
              v-if="
                !info.fileId &&
                !(
                  info.medalName?.includes('流光') ||
                  info.medalName?.includes('星光') ||
                  info.medalName?.includes('荣光') ||
                  info.medalName?.includes('雷士')
                )
              "
              class="img1"
              src="@/assets/newMedal/history/rong.svg"
              alt=""
            /> -->
            <img
              v-if="info.fileId"
              class="img1"
              :src="imgUrl + info.fileId"
              alt=""
            />
            <div class="position_text" v-if="!info.fileId">
              <div class="t1">
                {{ info.medalName }}
                <!-- {{
                  info.medalType == 1
                    ? "流光勋章"
                    : info.medalType == 2
                    ? "星光勋章"
                    : info.medalType == 3
                    ? "荣光勋章"
                    : info.medalType == 4
                    ? "雷士照明勋章"
                    : ""
                }} -->
              </div>
              <div class="t2">
                {{
                  info.medalName?.includes("流光")
                    ? "LiuGuangXunZhang"
                    : info.medalName?.includes("星光")
                    ? "XingGuangXunZhang"
                    : info.medalName?.includes("荣光")
                    ? "RongGuangXunZhang"
                    : info.medalName?.includes("雷士照明")
                    ? "LeiShiZhaoMing"
                    : ""
                }}
              </div>
            </div>
            <img class="img2" :src="imgUrl + info.iconId" alt="" />
          </div>
          <div class="fild_label">
            <div>项目名称</div>
          </div>
          <div class="fild_value">
            <el-input v-model="info.title" placeholder="请输入" readonly>
            </el-input>
          </div>
          <div class="fild_label">
            <div>获得勋章类型</div>
          </div>
          <div class="fild_value">
            <el-input v-model="info.medalName" placeholder="请输入" readonly>
            </el-input>
          </div>
          <div class="fild_label">
            <div>提名标准</div>
          </div>
          <div class="fild_value3">
            <el-input
              v-model="info.nominateStandardValue"
              placeholder="请输入"
              readonly
              type="textarea"
              autosize
            >
            </el-input>
          </div>
          <div class="fild_label">
            <div>项目成员</div>
          </div>
          <div class="fild_value3">
            <el-input
              v-model="info.awardeeName"
              placeholder="请输入"
              type="textarea"
              autosize
              readonly
            >
            </el-input>
          </div>
          <div class="fild_label fild_label2">
            <div>成果展示</div>
          </div>
          <div class="fild_value mainRemark">
            <quill-editor
              ref="myQuillEditor"
              v-model="info.achievement"
              :options="editorOption"
              :disabled="true"
            ></quill-editor>
            <!-- <van-field
              v-model="info.achievement"
              readonly
              rows="4"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="请输入感谢理由，内容仅限200字以内。"
              show-word-limit
            /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//   import moment from "moment";
//   import apiLogin from "@/apis";
//   import { getToken } from "@/utils/cookie";
// import apis from "@/apis";
import api from "@/apis/medal";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  name: "quaquaka",
  components: {},
  data() {
    return {
      valueName: "名称",
      message: "",
      info: {},
      editorOption: {
        modules: {
          toolbar: ""
        }
      },
      imgUrl: ""
    };
  },
  created() {},
  mounted() {
    //获取图片地址
    this.imgUrl = api.imgUrl;
    this.info = JSON.parse(localStorage.getItem("historyDetail"));
  },
  //销毁时清除数据
  beforeDestroy() {
    localStorage.removeItem("historyDetail");
  },
  methods: {
    //返回
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
    // background: rgba(244, 245, 248, 1);
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
  .mainRemark {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
    // background: rgba(244, 245, 248, 1);
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
  .mainRemark {
    width: 276px * $zoom;
  }
}

.box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.container {
  padding: 30px;
  .content {
    width: 100%;
    height: 87vh;
    border-radius: 40px;
    background: #fff;
    overflow: auto;
    padding: 10px 40px 40px;
    &::-webkit-scrollbar {
      display: none;
    }
    .top {
      display: flex;
      justify-content: center;
      position: relative;
      margin-top: 45px;
      .img1 {
        width: 98%;
      }
      .position_text {
        position: absolute;
        color: #a76a33;
        top: 24%;
        left: 10%;
        .t1 {
          font-size: 48px;
          font-weight: bold;
          letter-spacing: 10px;
        }
        .t2 {
          font-size: 26px;
          letter-spacing: 1px;
        }
      }
      .img2 {
        position: absolute;
        top: -60px;
        right: -3%;
        // width: 350px;
        width: 50%;
        // height: 23vh;
      }
    }
    .fild_label {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      margin-top: 30px;
      div {
        color: #0a1629;
        font-weight: bold;
        font-size: 30px;
      }
    }
    .fild_label3 {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      margin-bottom: 20px;
      .label_left {
        display: flex;
        align-items: flex-start;
        div {
          color: #0a1629;
          font-weight: bold;
          font-size: 32px;
        }
      }
      span {
        color: #ff4d4d;
        margin-right: 5px;
        font-size: 32px;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    .fild_value3 {
      ::v-deep {
        .el-textarea__inner {
          width: 100%;
          height: 80px;
          border-radius: 16px;
          background: #fafafa;
          border: none;
          font-size: 30px;
          &::-webkit-resizer {
            display: none;
          }
        }
        .van-cell {
          border-radius: 16px;
          background: #fafafa;
        }
      }
    }
    .fild_value {
      width: 100%;
      ::v-deep {
        .el-input {
          width: 100%;
        }
        .el-select {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 80px;
          border-radius: 16px;
          background: #fafafa;
          border: none;
          font-size: 30px;
        }
        .van-cell {
          border-radius: 16px;
          background: #fafafa;
        }
      }
    }
    .fild_tag {
      font-size: 28px;
      color: #999999;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .tags {
        width: 150px;
        text-align: center;
        margin-bottom: 15px;
        div {
          text-align: center;
        }
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-bottom: 10px;
          text-align: center;
        }
      }
    }
    .message {
      font-size: 26px;
      color: #969b9e;
      line-height: 38px;
      margin-top: 20px;
    }
    // margin-bottom: 30px;
  }
}

.submit {
  margin-top: 4vh;
  ::v-deep {
    .el-button {
      width: 100%;
      height: 80px;
      background: #1fbe8a;
      color: #fff;
      font-size: 32px;
      border-radius: 16px;
    }
  }
}

.goback {
  margin: 10px 40px 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
::v-deep .mainRemark {
  // border: 1px solid #f1f1f1;
  border-radius: 12px;
  margin-bottom: 30px;
  img {
    width: 100%;
    height: 100%;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  .ql-editor {
    min-height: 200px;
    // max-height: 300px;
  }
  .ql-container.ql-snow {
    border-radius: 12px;
    border-color: #f1f1f1;
  }
  .ql-editor.ql-blank::before {
    content: "";
  }
}
</style>
